import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  margin-right: 8px;

  svg {
    font-size: 14px;
  }
`;
